// extracted by mini-css-extract-plugin
export default {"popover_body":"PopoverAsTooltip_popover_body__c3DaC","popover_content":"PopoverAsTooltip_popover_content__pEbfC"};